import React, { useState } from 'react';
import { UserDashboardChartsProps } from 'src/pages/dashboard/Dashboard.interface';
import { boardI18nStrings, boardItemI18nStrings } from 'src/components/dashboard/DashboardConstants';
import Header from '@amzn/awsui-components-console/header';
import Board, { BoardProps } from '@amzn/awsui-board-components-console/board';
import BoardItem from '@amzn/awsui-board-components-console/board-item';
import EmptyState from 'src/components/commonComponents/EmptyState/EmptyState';
import UserAllWorkflowsChart from './UserAllWorkflowsChart';
import UserWorkflowMetricsChart from './UserWorkflowMetricsChart';

interface BoardItemData { title: string; }

export default function UserDashboardCharts({ year, userId, workflowTypes, month, workflowNameMap }: UserDashboardChartsProps) {
	const showAllWorkflows = workflowTypes.length === 0;

	const boardDescription = showAllWorkflows
		? `User: ${userId} | Year: ${year}`
		: `User: ${userId} | Workflows: ${workflowTypes.length} selected | Year: ${year}`;

	const [boardItems, setBoardItems] = useState<BoardProps.Item<BoardItemData>[]>([{
		id: 'user-metrics',
		definition: { defaultRowSpan: 7, defaultColumnSpan: 4 },
		columnOffset: { 4: 0 }, rowSpan: 7, columnSpan: 4,
		data: { title: 'User Workflow Metrics' },
	}]);

	return (
		<Board<BoardItemData>
			items={boardItems}
			onItemsChange={({ detail }) => setBoardItems(detail.items as BoardProps.Item<BoardItemData>[])}
			i18nStrings={boardI18nStrings}
			empty={<EmptyState title="No widgets available" />}
			renderItem={(item) => (
				<BoardItem
					header={<Header description={boardDescription}>{item.data?.title}</Header>}
					i18nStrings={boardItemI18nStrings}
				>
					{showAllWorkflows ? (
						<UserAllWorkflowsChart year={year} userId={userId} month={month} workflowNameMap={workflowNameMap} />
					) : (
						<UserWorkflowMetricsChart year={year} userId={userId} workflowTypes={workflowTypes} month={month} workflowNameMap={workflowNameMap} />
					)}
				</BoardItem>
			)}
		/>
	);
}
